import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'my-projects',
  children: {
    employeeId: {
      size: 'full',
      path: ':employeeId',
      children: {
        overview: {
          size: 'full',
          path: 'overview',
        },
        yearMonthDay: {
          size: 'full',
          path: ':year/:month/:day',
        },
        schedule: {
          size: 'full',
          path: 'schedule',
        },
      },
    },
  },
} as const satisfies Location
